import React from 'react'

function register_doctorate() {
  return (
    <div>
      
    </div>
  )
}

export default register_doctorate
